import React from "react";
import { NavButton } from "../../components";
import "./HomePage.css";

export function HomePage() {
  return (
    <div className="container">
      <div className="homeContainer">
        <h1>Canadian National E-Basketball Event</h1>
        <h2>Streaming Hub</h2>
        <div className="buttonBar">
          <NavButton text="To Schedule" route="/schedule" />
          <NavButton text="To Standings" route="/standings" />
          <NavButton text="To Playoffs" route="/playoffs" />
          <NavButton text="To Stream" route="/stream/1" />
        </div>
      </div>
    </div>
  );
}
